import React, { ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; errorInfo: string; }

/**
 * AppErrorBoundary — Top-level crash guard.
 * Agar koi bhi React component crash kare, poora app blank nahi hoga.
 * User ko graceful recovery screen milega.
 */
export class AppErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: '' };
    this.handleReload = this.handleReload.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: '' };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('[Aarthika] App crash caught:', error, info);
    this.setState({ errorInfo: info.componentStack?.slice(0, 300) || '' });
  }

  handleReload() {
    window.location.reload();
  }

  handleReset() {
    this.setState({ hasError: false, error: null, errorInfo: '' });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100vh', width: '100vw',
        background: '#f1f5f9', fontFamily: 'Inter, sans-serif',
      }}>
        <div style={{
          background: 'white', border: '1px solid #e2e8f0',
          borderRadius: '4px', padding: '40px 48px',
          maxWidth: '480px', width: '100%', textAlign: 'center',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        }}>
          {/* Header strip */}
          <div style={{
            background: '#1e8585', borderRadius: '2px',
            padding: '10px 20px', marginBottom: '28px',
            marginLeft: '-48px', marginRight: '-48px', marginTop: '-40px',
          }}>
            <span style={{ color: 'white', fontWeight: 700, fontSize: '15px', letterSpacing: '1px' }}>
              AARTHIKA SOFTS
            </span>
          </div>

          <div style={{ fontSize: '36px', marginBottom: '12px' }}>⚠</div>
          <h2 style={{ color: '#1e293b', fontSize: '16px', fontWeight: 700, marginBottom: '8px' }}>
            An unexpected error occurred
          </h2>
          <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '8px', lineHeight: 1.6 }}>
            Aapka data safe hai. App reload karke dobara try karein.
          </p>
          {this.state.error && (
            <p style={{
              color: '#94a3b8', fontSize: '11px', fontFamily: 'monospace',
              background: '#f8fafc', border: '1px solid #e2e8f0',
              borderRadius: '3px', padding: '8px', marginBottom: '20px',
              textAlign: 'left', wordBreak: 'break-all',
            }}>
              {this.state.error.message}
            </p>
          )}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: '8px 20px', background: 'white', color: '#1e8585',
                border: '1.5px solid #1e8585', borderRadius: '3px',
                fontWeight: 600, fontSize: '13px', cursor: 'pointer',
              }}
            >
              Try Again
            </button>
            <button
              onClick={this.handleReload}
              style={{
                padding: '8px 20px', background: '#1e8585', color: 'white',
                border: 'none', borderRadius: '3px',
                fontWeight: 700, fontSize: '13px', cursor: 'pointer',
              }}
            >
              Reload App
            </button>
          </div>
        </div>
        <p style={{ color: '#94a3b8', fontSize: '11px', marginTop: '16px' }}>
          Baar baar aaye to support se contact karein
        </p>
      </div>
    );
  }
}
